export const UserType = {
    CLIENT: "client",
    SUPPLIER: "supplier",
    ADMIN: "admin",
} as const;

export type UserType = typeof UserType[keyof typeof UserType];

export const SocialMediaPlatform = {
    FACEBOOK: "facebook",
    GOOGLE: "google",
    TIKTOK: "tiktok",
} as const;

export type SocialMediaPlatform = typeof SocialMediaPlatform[keyof typeof SocialMediaPlatform];

export const AdType = {
    WHITE_HAT: "white-hat",
    BLACK_HAT: "black-hat",
    GREY_HAT: "grey-hat",
} as const;

export type AdType = typeof AdType[keyof typeof AdType];

export const ClientStatus = {
    UNVALIDATED: "unvalidated",
    REJECTED: "rejected",
    ACTIVE: "active",
    INACTIVE: "inactive",
} as const;

export type ClientStatus = typeof ClientStatus[keyof typeof ClientStatus];

export const FeeType = {
    ONE_TIME: "one-time",
    MONTHLY: "monthly",
} as const;

export type FeeType = typeof FeeType[keyof typeof FeeType];

export const SupplierType = {
    MANUAL: "manual",
    ROCKADS: "rockads",
    SLACK: "slack",
    META: "meta",
    IMARKETING: "imarketing",
} as const;

export type SupplierType = typeof SupplierType[keyof typeof SupplierType];

export const Currency = {
    EUR: "EUR",
    USD: "USD",
} as const;

export type Currency = typeof Currency[keyof typeof Currency];

export const AdAccountStatus = {
    PENDING: "pending",
    APPROVED: "approved",
    REJECTED: "rejected",
    BANNED: "banned",
    SUSPENDED: "suspended",
    ON_HOLD: "on-hold",
} as const;

export type AdAccountStatus = typeof AdAccountStatus[keyof typeof AdAccountStatus];

export const Timezone = {
    AfricaAbidjan: "africa-abidjan",
    AfricaAccra: "africa-accra",
    AfricaAddisAbaba: "africa-addis-ababa",
    AfricaAlgiers: "africa-algiers",
    AfricaAsmara: "africa-asmara",
    AfricaBamako: "africa-bamako",
    AfricaBangui: "africa-bangui",
    AfricaBanjul: "africa-banjul",
    AfricaBissau: "africa-bissau",
    AfricaBlantyre: "africa-blantyre",
    AfricaBrazzaville: "africa-brazzaville",
    AfricaBujumbura: "africa-bujumbura",
    AfricaCairo: "africa-cairo",
    AfricaCasablanca: "africa-casablanca",
    AfricaCeuta: "africa-ceuta",
    AfricaConakry: "africa-conakry",
    AfricaDakar: "africa-dakar",
    AfricaDarEsSalaam: "africa-dar-es-salaam",
    AfricaDjibouti: "africa-djibouti",
    AfricaDouala: "africa-douala",
    AfricaElAaiun: "africa-el-aaiun",
    AfricaFreetown: "africa-freetown",
    AfricaGaborone: "africa-gaborone",
    AfricaHarare: "africa-harare",
    AfricaJohannesburg: "africa-johannesburg",
    AfricaJuba: "africa-juba",
    AfricaKampala: "africa-kampala",
    AfricaKhartoum: "africa-khartoum",
    AfricaKigali: "africa-kigali",
    AfricaKinshasa: "africa-kinshasa",
    AfricaLagos: "africa-lagos",
    AfricaLibreville: "africa-libreville",
    AfricaLome: "africa-lome",
    AfricaLuanda: "africa-luanda",
    AfricaLubumbashi: "africa-lubumbashi",
    AfricaLusaka: "africa-lusaka",
    AfricaMalabo: "africa-malabo",
    AfricaMaputo: "africa-maputo",
    AfricaMaseru: "africa-maseru",
    AfricaMbabane: "africa-mbabane",
    AfricaMogadishu: "africa-mogadishu",
    AfricaMonrovia: "africa-monrovia",
    AfricaNairobi: "africa-nairobi",
    AfricaNdjamena: "africa-ndjamena",
    AfricaNiamey: "africa-niamey",
    AfricaNouakchott: "africa-nouakchott",
    AfricaOuagadougou: "africa-ouagadougou",
    AfricaPortoNovo: "africa-porto-novo",
    AfricaSaoTome: "africa-sao-tome",
    AfricaTripoli: "africa-tripoli",
    AfricaTunis: "africa-tunis",
    AfricaWindhoek: "africa-windhoek",
    AmericaAdak: "america-adak",
    AmericaAnchorage: "america-anchorage",
    AmericaAnguilla: "america-anguilla",
    AmericaAntigua: "america-antigua",
    AmericaAraguaina: "america-araguaina",
    AmericaArgentinaBuenosAires: "america-argentina-buenos-aires",
    AmericaArgentinaCatamarca: "america-argentina-catamarca",
    AmericaArgentinaCordoba: "america-argentina-cordoba",
    AmericaArgentinaJujuy: "america-argentina-jujuy",
    AmericaArgentinaLaRioja: "america-argentina-la-rioja",
    AmericaArgentinaMendoza: "america-argentina-mendoza",
    AmericaArgentinaRioGallegos: "america-argentina-rio-gallegos",
    AmericaArgentinaSalta: "america-argentina-salta",
    AmericaArgentinaSanJuan: "america-argentina-san-juan",
    AmericaArgentinaSanLuis: "america-argentina-san-luis",
    AmericaArgentinaTucuman: "america-argentina-tucuman",
    AmericaArgentinaUshuaia: "america-argentina-ushuaia",
    AmericaAruba: "america-aruba",
    AmericaAsuncion: "america-asuncion",
    AmericaAtikokan: "america-atikokan",
    AmericaBahia: "america-bahia",
    AmericaBahiaBanderas: "america-bahia-banderas",
    AmericaBarbados: "america-barbados",
    AmericaBelem: "america-belem",
    AmericaBelize: "america-belize",
    AmericaBlancSablon: "america-blanc-sablon",
    AmericaBoaVista: "america-boa-vista",
    AmericaBogota: "america-bogota",
    AmericaBoise: "america-boise",
    AmericaCambridgeBay: "america-cambridge-bay",
    AmericaCampoGrande: "america-campo-grande",
    AmericaCancun: "america-cancun",
    AmericaCaracas: "america-caracas",
    AmericaCayenne: "america-cayenne",
    AmericaCayman: "america-cayman",
    AmericaChicago: "america-chicago",
    AmericaChihuahua: "america-chihuahua",
    AmericaCostaRica: "america-costa-rica",
    AmericaCreston: "america-creston",
    AmericaCuiaba: "america-cuiaba",
    AmericaCuracao: "america-curacao",
    AmericaDanmarkshavn: "america-danmarkshavn",
    AmericaDawson: "america-dawson",
    AmericaDawsonCreek: "america-dawson-creek",
    AmericaDenver: "america-denver",
    AmericaDetroit: "america-detroit",
    AmericaDominica: "america-dominica",
    AmericaEdmonton: "america-edmonton",
    AmericaEirunepe: "america-eirunepe",
    AmericaElSalvador: "america-el-salvador",
    AmericaFortNelson: "america-fort-nelson",
    AmericaFortaleza: "america-fortaleza",
    AmericaGlaceBay: "america-glace-bay",
    AmericaGodthab: "america-godthab",
    AmericaGooseBay: "america-goose-bay",
    AmericaGrandTurk: "america-grand-turk",
    AmericaGrenada: "america-grenada",
    AmericaGuadeloupe: "america-guadeloupe",
    AmericaGuatemala: "america-guatemala",
    AmericaGuayaquil: "america-guayaquil",
    AmericaGuyana: "america-guyana",
    AmericaHalifax: "america-halifax",
    AmericaHavana: "america-havana",
    AmericaHermosillo: "america-hermosillo",
    AmericaIndianaIndianapolis: "america-indiana-indianapolis",
    AmericaIndianaKnox: "america-indiana-knox",
    AmericaIndianaMarengo: "america-indiana-marengo",
    AmericaIndianaPetersburg: "america-indiana-petersburg",
    AmericaIndianaTellCity: "america-indiana-tell-city",
    AmericaIndianaVevay: "america-indiana-vevay",
    AmericaIndianaVincennes: "america-indiana-vincennes",
    AmericaIndianaWinamac: "america-indiana-winamac",
    AmericaIndianapolis: "america-indianapolis",
    AmericaInuvik: "america-inuvik",
    AmericaIqaluit: "america-iqaluit",
    AmericaJamaica: "america-jamaica",
    AmericaJuneau: "america-juneau",
    AmericaKentuckyLouisville: "america-kentucky-louisville",
    AmericaKentuckyMonticello: "america-kentucky-monticello",
    AmericaKralendijk: "america-kralendijk",
    AmericaLaPaz: "america-la-paz",
    AmericaLima: "america-lima",
    AmericaLosAngeles: "america-los-angeles",
    AmericaLowerPrinces: "america-lower-princes",
    AmericaMaceio: "america-maceio",
    AmericaManagua: "america-managua",
    AmericaManaus: "america-manaus",
    AmericaMarigot: "america-marigot",
    AmericaMartinique: "america-martinique",
    AmericaMatamoros: "america-matamoros",
    AmericaMazatlan: "america-mazatlan",
    AmericaMenominee: "america-menominee",
    AmericaMerida: "america-merida",
    AmericaMetlakatla: "america-metlakatla",
    AmericaMexicoCity: "america-mexico-city",
    AmericaMiquelon: "america-miquelon",
    AmericaMoncton: "america-moncton",
    AmericaMonterrey: "america-monterrey",
    AmericaMontevideo: "america-montevideo",
    AmericaMontreal: "america-montreal",
    AmericaMontserrat: "america-montserrat",
    AmericaNassau: "america-nassau",
    AmericaNewYork: "america-new-york",
    AmericaNipigon: "america-nipigon",
    AmericaNome: "america-nome",
    AmericaNoronha: "america-noronha",
    AmericaNorthDakotaBeulah: "america-north-dakota-beulah",
    AmericaNorthDakotaCenter: "america-north-dakota-center",
    AmericaNorthDakotaNewSalem: "america-north-dakota-new-salem",
    AmericaNuuk: "america-nuuk",
    AmericaOjinaga: "america-ojinaga",
    AmericaPanama: "america-panama",
    AmericaPangnirtung: "america-pangnirtung",
    AmericaParamaribo: "america-paramaribo",
    AmericaPhoenix: "america-phoenix",
    AmericaPortAuPrince: "america-port-au-prince",
    AmericaPortOfSpain: "america-port-of-spain",
    AmericaPortoVelho: "america-porto-velho",
    AmericaPuertoRico: "america-puerto-rico",
    AmericaPuntaArenas: "america-punta-arenas",
    AmericaRainyRiver: "america-rainy-river",
    AmericaRankinInlet: "america-rankin-inlet",
    AmericaRecife: "america-recife",
    AmericaRegina: "america-regina",
    AmericaResolute: "america-resolute",
    AmericaRioBranco: "america-rio-branco",
    AmericaSantarem: "america-santarem",
    AmericaSantiago: "america-santiago",
    AmericaSantoDomingo: "america-santo-domingo",
    AmericaSaoPaulo: "america-sao-paulo",
    AmericaScoresbysund: "america-scoresbysund",
    AmericaSitka: "america-sitka",
    AmericaStBarthelemy: "america-st-barthelemy",
    AmericaStJohns: "america-st-johns",
    AmericaStKitts: "america-st-kitts",
    AmericaStLucia: "america-st-lucia",
    AmericaStThomas: "america-st-thomas",
    AmericaStVincent: "america-st-vincent",
    AmericaSwiftCurrent: "america-swift-current",
    AmericaTegucigalpa: "america-tegucigalpa",
    AmericaThule: "america-thule",
    AmericaThunderBay: "america-thunder-bay",
    AmericaTijuana: "america-tijuana",
    AmericaToronto: "america-toronto",
    AmericaTortola: "america-tortola",
    AmericaVancouver: "america-vancouver",
    AmericaWhitehorse: "america-whitehorse",
    AmericaWinnipeg: "america-winnipeg",
    AmericaYakutat: "america-yakutat",
    AmericaYellowknife: "america-yellowknife",
    AntarcticaCasey: "antarctica-casey",
    AntarcticaDavis: "antarctica-davis",
    AntarcticaDumontdurville: "antarctica-dumontdurville",
    AntarcticaMacquarie: "antarctica-macquarie",
    AntarcticaMawson: "antarctica-mawson",
    AntarcticaMcmurdo: "antarctica-mcmurdo",
    AntarcticaPalmer: "antarctica-palmer",
    AntarcticaRothera: "antarctica-rothera",
    AntarcticaSyowa: "antarctica-syowa",
    AntarcticaTroll: "antarctica-troll",
    AntarcticaVostok: "antarctica-vostok",
    ArcticLongyearbyen: "arctic-longyearbyen",
    AsiaAden: "asia-aden",
    AsiaAlmaty: "asia-almaty",
    AsiaAmman: "asia-amman",
    AsiaAnadyr: "asia-anadyr",
    AsiaAqtau: "asia-aqtau",
    AsiaAqtobe: "asia-aqtobe",
    AsiaAshgabat: "asia-ashgabat",
    AsiaAtyrau: "asia-atyrau",
    AsiaBaghdad: "asia-baghdad",
    AsiaBahrain: "asia-bahrain",
    AsiaBaku: "asia-baku",
    AsiaBangkok: "asia-bangkok",
    AsiaBarnaul: "asia-barnaul",
    AsiaBeirut: "asia-beirut",
    AsiaBishkek: "asia-bishkek",
    AsiaBrunei: "asia-brunei",
    AsiaCalcutta: "asia-calcutta",
    AsiaChita: "asia-chita",
    AsiaChoibalsan: "asia-choibalsan",
    AsiaColombo: "asia-colombo",
    AsiaDamascus: "asia-damascus",
    AsiaDhaka: "asia-dhaka",
    AsiaDili: "asia-dili",
    AsiaDubai: "asia-dubai",
    AsiaDushanbe: "asia-dushanbe",
    AsiaFamagusta: "asia-famagusta",
    AsiaGaza: "asia-gaza",
    AsiaHebron: "asia-hebron",
    AsiaHoChiMinh: "asia-ho-chi-minh",
    AsiaHongKong: "asia-hong-kong",
    AsiaHovd: "asia-hovd",
    AsiaIrkutsk: "asia-irkutsk",
    AsiaIstanbul: "asia-istanbul",
    AsiaJakarta: "asia-jakarta",
    AsiaJayapura: "asia-jayapura",
    AsiaJerusalem: "asia-jerusalem",
    AsiaKabul: "asia-kabul",
    AsiaKamchatka: "asia-kamchatka",
    AsiaKarachi: "asia-karachi",
    AsiaKathmandu: "asia-kathmandu",
    AsiaKatmandu: "asia-katmandu",
    AsiaKhandyga: "asia-khandyga",
    AsiaKolkata: "asia-kolkata",
    AsiaKrasnoyarsk: "asia-krasnoyarsk",
    AsiaKualaLumpur: "asia-kuala-lumpur",
    AsiaKuching: "asia-kuching",
    AsiaKuwait: "asia-kuwait",
    AsiaMacau: "asia-macau",
    AsiaMagadan: "asia-magadan",
    AsiaMakassar: "asia-makassar",
    AsiaManila: "asia-manila",
    AsiaMuscat: "asia-muscat",
    AsiaNicosia: "asia-nicosia",
    AsiaNovokuznetsk: "asia-novokuznetsk",
    AsiaNovosibirsk: "asia-novosibirsk",
    AsiaOmsk: "asia-omsk",
    AsiaOral: "asia-oral",
    AsiaPhnomPenh: "asia-phnom-penh",
    AsiaPontianak: "asia-pontianak",
    AsiaPyongyang: "asia-pyongyang",
    AsiaQatar: "asia-qatar",
    AsiaQostanay: "asia-qostanay",
    AsiaQyzylorda: "asia-qyzylorda",
    AsiaRiyadh: "asia-riyadh",
    AsiaSakhalin: "asia-sakhalin",
    AsiaSamarkand: "asia-samarkand",
    AsiaSeoul: "asia-seoul",
    AsiaShanghai: "asia-shanghai",
    AsiaSingapore: "asia-singapore",
    AsiaSrednekolymsk: "asia-srednekolymsk",
    AsiaTaipei: "asia-taipei",
    AsiaTashkent: "asia-tashkent",
    AsiaTbilisi: "asia-tbilisi",
    AsiaTehran: "asia-tehran",
    AsiaThimphu: "asia-thimphu",
    AsiaTokyo: "asia-tokyo",
    AsiaTomsk: "asia-tomsk",
    AsiaUlaanbaatar: "asia-ulaanbaatar",
    AsiaUrumqi: "asia-urumqi",
    AsiaUstNera: "asia-ust-nera",
    AsiaVientiane: "asia-vientiane",
    AsiaVladivostok: "asia-vladivostok",
    AsiaYakutsk: "asia-yakutsk",
    AsiaYangon: "asia-yangon",
    AsiaYekaterinburg: "asia-yekaterinburg",
    AsiaYerevan: "asia-yerevan",
    AtlanticAzores: "atlantic-azores",
    AtlanticBermuda: "atlantic-bermuda",
    AtlanticCanary: "atlantic-canary",
    AtlanticCapeVerde: "atlantic-cape-verde",
    AtlanticFaroe: "atlantic-faroe",
    AtlanticMadeira: "atlantic-madeira",
    AtlanticReykjavik: "atlantic-reykjavik",
    AtlanticSouthGeorgia: "atlantic-south-georgia",
    AtlanticStHelena: "atlantic-st-helena",
    AtlanticStanley: "atlantic-stanley",
    AustraliaAdelaide: "australia-adelaide",
    AustraliaBrisbane: "australia-brisbane",
    AustraliaBrokenHill: "australia-broken-hill",
    AustraliaCurrie: "australia-currie",
    AustraliaDarwin: "australia-darwin",
    AustraliaEucla: "australia-eucla",
    AustraliaHobart: "australia-hobart",
    AustraliaLindeman: "australia-lindeman",
    AustraliaLordHowe: "australia-lord-howe",
    AustraliaMelbourne: "australia-melbourne",
    AustraliaPerth: "australia-perth",
    AustraliaSydney: "australia-sydney",
    Cet: "cet",
    Cst6cdt: "cst6cdt",
    Eet: "eet",
    Est: "est",
    Est5edt: "est5edt",
    EtcGmt: "etc-gmt",
    EtcGmtMinus0: "etc-gmt-minus-0",
    EtcGmtMinus1: "etc-gmt-minus-1",
    EtcGmtMinus10: "etc-gmt-minus-10",
    EtcGmtMinus11: "etc-gmt-minus-11",
    EtcGmtMinus12: "etc-gmt-minus-12",
    EtcGmtMinus13: "etc-gmt-minus-13",
    EtcGmtMinus14: "etc-gmt-minus-14",
    EtcGmtMinus2: "etc-gmt-minus-2",
    EtcGmtMinus3: "etc-gmt-minus-3",
    EtcGmtMinus4: "etc-gmt-minus-4",
    EtcGmtMinus5: "etc-gmt-minus-5",
    EtcGmtMinus6: "etc-gmt-minus-6",
    EtcGmtMinus7: "etc-gmt-minus-7",
    EtcGmtMinus8: "etc-gmt-minus-8",
    EtcGmtMinus9: "etc-gmt-minus-9",
    EtcGmtPlus0: "etc-gmt-plus-0",
    EtcGmtPlus1: "etc-gmt-plus-1",
    EtcGmtPlus10: "etc-gmt-plus-10",
    EtcGmtPlus11: "etc-gmt-plus-11",
    EtcGmtPlus12: "etc-gmt-plus-12",
    EtcGmtPlus2: "etc-gmt-plus-2",
    EtcGmtPlus3: "etc-gmt-plus-3",
    EtcGmtPlus4: "etc-gmt-plus-4",
    EtcGmtPlus5: "etc-gmt-plus-5",
    EtcGmtPlus6: "etc-gmt-plus-6",
    EtcGmtPlus7: "etc-gmt-plus-7",
    EtcGmtPlus8: "etc-gmt-plus-8",
    EtcGmtPlus9: "etc-gmt-plus-9",
    EtcGmt0: "etc-gmt0",
    EtcGreenwich: "etc-greenwich",
    EtcUniversal: "etc-universal",
    EtcZulu: "etc-zulu",
    EuropeAmsterdam: "europe-amsterdam",
    EuropeAndorra: "europe-andorra",
    EuropeAstrakhan: "europe-astrakhan",
    EuropeAthens: "europe-athens",
    EuropeBelgrade: "europe-belgrade",
    EuropeBerlin: "europe-berlin",
    EuropeBratislava: "europe-bratislava",
    EuropeBrussels: "europe-brussels",
    EuropeBucharest: "europe-bucharest",
    EuropeBudapest: "europe-budapest",
    EuropeBusingen: "europe-busingen",
    EuropeChisinau: "europe-chisinau",
    EuropeCopenhagen: "europe-copenhagen",
    EuropeDublin: "europe-dublin",
    EuropeGibraltar: "europe-gibraltar",
    EuropeGuernsey: "europe-guernsey",
    EuropeHelsinki: "europe-helsinki",
    EuropeIsleOfMan: "europe-isle-of-man",
    EuropeIstanbul: "europe-istanbul",
    EuropeJersey: "europe-jersey",
    EuropeKaliningrad: "europe-kaliningrad",
    EuropeKiev: "europe-kiev",
    EuropeKirov: "europe-kirov",
    EuropeLisbon: "europe-lisbon",
    EuropeLjubljana: "europe-ljubljana",
    EuropeLondon: "europe-london",
    EuropeLuxembourg: "europe-luxembourg",
    EuropeMadrid: "europe-madrid",
    EuropeMalta: "europe-malta",
    EuropeMariehamn: "europe-mariehamn",
    EuropeMinsk: "europe-minsk",
    EuropeMonaco: "europe-monaco",
    EuropeMoscow: "europe-moscow",
    EuropeNicosia: "europe-nicosia",
    EuropeOslo: "europe-oslo",
    EuropeParis: "europe-paris",
    EuropePodgorica: "europe-podgorica",
    EuropePrague: "europe-prague",
    EuropeRiga: "europe-riga",
    EuropeRome: "europe-rome",
    EuropeSamara: "europe-samara",
    EuropeSanMarino: "europe-san-marino",
    EuropeSarajevo: "europe-sarajevo",
    EuropeSaratov: "europe-saratov",
    EuropeSimferopol: "europe-simferopol",
    EuropeSkopje: "europe-skopje",
    EuropeSofia: "europe-sofia",
    EuropeStockholm: "europe-stockholm",
    EuropeTallinn: "europe-tallinn",
    EuropeTirane: "europe-tirane",
    EuropeUlyanovsk: "europe-ulyanovsk",
    EuropeUzhgorod: "europe-uzhgorod",
    EuropeVaduz: "europe-vaduz",
    EuropeVatican: "europe-vatican",
    EuropeVienna: "europe-vienna",
    EuropeVilnius: "europe-vilnius",
    EuropeVolgograd: "europe-volgograd",
    EuropeWarsaw: "europe-warsaw",
    EuropeZagreb: "europe-zagreb",
    EuropeZaporozhye: "europe-zaporozhye",
    EuropeZurich: "europe-zurich",
    Gmt: "gmt",
    Hst: "hst",
    IndianAntananarivo: "indian-antananarivo",
    IndianChagos: "indian-chagos",
    IndianChristmas: "indian-christmas",
    IndianCocos: "indian-cocos",
    IndianComoro: "indian-comoro",
    IndianKerguelen: "indian-kerguelen",
    IndianMahe: "indian-mahe",
    IndianMaldives: "indian-maldives",
    IndianMauritius: "indian-mauritius",
    IndianMayotte: "indian-mayotte",
    IndianReunion: "indian-reunion",
    Met: "met",
    Mst: "mst",
    Mst7mdt: "mst7mdt",
    PacificApia: "pacific-apia",
    PacificAuckland: "pacific-auckland",
    PacificBougainville: "pacific-bougainville",
    PacificChatham: "pacific-chatham",
    PacificChuuk: "pacific-chuuk",
    PacificEaster: "pacific-easter",
    PacificEfate: "pacific-efate",
    PacificEnderbury: "pacific-enderbury",
    PacificFakaofo: "pacific-fakaofo",
    PacificFiji: "pacific-fiji",
    PacificFunafuti: "pacific-funafuti",
    PacificGalapagos: "pacific-galapagos",
    PacificGambier: "pacific-gambier",
    PacificGuadalcanal: "pacific-guadalcanal",
    PacificGuam: "pacific-guam",
    PacificHonolulu: "pacific-honolulu",
    PacificKiritimati: "pacific-kiritimati",
    PacificKosrae: "pacific-kosrae",
    PacificKwajalein: "pacific-kwajalein",
    PacificMajuro: "pacific-majuro",
    PacificMarquesas: "pacific-marquesas",
    PacificMidway: "pacific-midway",
    PacificNauru: "pacific-nauru",
    PacificNiue: "pacific-niue",
    PacificNorfolk: "pacific-norfolk",
    PacificNoumea: "pacific-noumea",
    PacificPagoPago: "pacific-pago-pago",
    PacificPalau: "pacific-palau",
    PacificPitcairn: "pacific-pitcairn",
    PacificPohnpei: "pacific-pohnpei",
    PacificPortMoresby: "pacific-port-moresby",
    PacificRarotonga: "pacific-rarotonga",
    PacificSaipan: "pacific-saipan",
    PacificTahiti: "pacific-tahiti",
    PacificTarawa: "pacific-tarawa",
    PacificTongatapu: "pacific-tongatapu",
    PacificWake: "pacific-wake",
    PacificWallis: "pacific-wallis",
    Pst8pdt: "pst8pdt",
    Utc: "utc",
    Wet: "wet",
};

export type Timezone = typeof Timezone[keyof typeof Timezone];

// Topup related constants
export const MINIMUM_TOPUP_AMOUNT = 300; // Deze waarde moet overeenkomen met MinimumTopupAmount::MINIMUM_AMOUNT in PHP
